export enum Constants {
  LOCAL_STORAGE_PROJECT_CODE_KEY = 'dialog-integration-project-code',
}
